import { render, staticRenderFns } from "./ProtectionJuridique.vue?vue&type=template&id=34a10b4d&"
import script from "./ProtectionJuridique.vue?vue&type=script&lang=js&"
export * from "./ProtectionJuridique.vue?vue&type=script&lang=js&"
import style0 from "./ProtectionJuridique.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports